import React, { FC } from "react";
import { Field } from "react-final-form";
import { Grid } from "@material-ui/core";
import BootstrapInput from "../../../../../components/BootstrapInput";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import { ICourseComponentProps } from "../../../types";

const AgeRange: FC<ICourseComponentProps> = ({ fieldsGroupName }) => (
  <div>
    <FieldsGroupLabel label="Age Range" className="fields-group-label" />
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={6}>
        <Field
          required
          fullWidth
          type="text"
          label="Minimum Age"
          placeholder={"Enter only number"}
          name={`${fieldsGroupName}.minAge`}
          component={BootstrapInput}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <Field
          fullWidth
          type="text"
          label="Maximum Age"
          placeholder={"Enter only number"}
          name={`${fieldsGroupName}.maxAge`}
          component={BootstrapInput}
        />
      </Grid>
    </Grid>
  </div>
);

export default React.memo(AgeRange);
